import BaseViewController from "./base-view-controller";
// import unmaskPhoneNumber from "../utils/mas";

class AuthorizedConsentersListViewController extends BaseViewController {
  formState = {};

  prepareSubmit(values) {
    // const phone_number = unmaskPhoneNumber('home_phone');
    return { ...values, ...this.formState };
  }

  handleButtonClick(name, text, action) {
    if (name === "selectedData") {
      this.formState = { ...text };
      this.formState.phone_number = this.formState.home_phone;
      delete this.formState.home_phone;
    }
    super.handleButtonClick(name, text, action);
  }
}

export default AuthorizedConsentersListViewController;
